export const REQUEST_DATA = {
  limit: 20,
  page: 1,
  query: ""
}

export const REQUEST_DATA_WITH_OFFSET = {
  limit: 20,
  offset: 0,
  page: 1,
  query: "",
}